<template>
  <div class="send-record">
    <div class="top">
      <Header ref="header" moduleTitle="预配舱单-上海">
        <template slot="searchBox">
          <DeleteSearch ref="deleteRecord" @fnSearch="searchList" @refreshSearch="refreshSearch" @exportExcel="exportExcel" />

        </template>
      </Header>
    </div>
    <div class="send-record-content">

      <WTable :WTableOpts="WTableOpts">
        <!-- <template #payOrderId="{ row }">
          <div class="flex">
            <div class="table-content">{{ row.payOrderId }}</div>
            <div class="content-center" v-if="row.payOrderId" @click="copy(row.payOrderId)"><i class="iconfont icon-fuzhi"></i></div>
          </div>
        </template> -->
        <template #masterBillNo="{ row }">
          <div class="flex">
            <div class="table-content">{{ row.masterBillNo }}</div>
            <div class="content-center" v-if="row.masterBillNo" @click="copy(row.masterBillNo)"><i class="iconfont icon-fuzhi"></i></div>
          </div>
        </template>
        <template #houseBillNo="{ row }">
          <div class="flex">
            <div class="table-content">{{ row.houseBillNo }}</div>
            <div class="content-center" v-if="row.houseBillNo" @click="copy(row.houseBillNo)"><i class="iconfont icon-fuzhi"></i></div>
          </div>
        </template>
        <template #shipName="{ row }">
          <div class="flex">
            <div class="table-content max-200">{{ row.shipName }}</div>
            <div class="content-center" v-if="row.shipName" @click="copy(row.shipName)"><i class="iconfont icon-fuzhi"></i></div>
          </div>
        </template>
        <template #voyageNo="{ row }">
          <div class="flex">
            <div class="table-content max-200">{{ row.voyageNo }}</div>
            <div class="content-center" v-if="row.voyageNo" @click="copy(row.voyageNo)"><i class="iconfont icon-fuzhi"></i></div>
          </div>
        </template>

        <template #ackStatus="{ row }">
          <div class="flex">
            <div class="table-content max-200" :class="getAckStatus(row.deleteStatus)" v-if="row.deleteStatus">{{ row.deleteStatus.show }}</div>
            <div v-else>/</div>
          </div>
        </template>

        <template #ackContent="{ row }">
          <div class="flex">
            <div class="table-content max-200" v-if="row.deleteStatus">{{ (row.deleteStatus.detail && row.deleteStatus.detail.remark) ? row.deleteStatus.detail.remark : '/' }}</div>
            <div v-else>/</div>
          </div>
        </template>

        <template #newOperator="{ row }">
          <span v-if="row.modifierUser && row.modifierUser.nickname">{{ row.modifierUser.nickname }}</span>
          <span v-else>{{ row.creatorUser ? row.creatorUser.nickname : '/' }}</span>
        </template>

        <template #operation="{ row }">
          <div class="table-btn-box">
            <el-link type="primary" :underline="false" @click="lookCps(row)">查看</el-link>
            <el-link type="primary" :underline="false" @click="copyCps(row)">复制</el-link>

          </div>
        </template>
      </WTable>
      <div class="pagination" v-if="total > 0">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageNum" :page-sizes="[10, 20, 50]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total" />
      </div>
    </div>
  </div>
</template>

<script>
import Header from "@/components/cps2/Header"
import DeleteSearch from "./search/DeleteSearch"
import download from "downloadjs"
import { httpAgent } from "@/api/ajax";

export default {
  name: "SendRecord",
  components: {
    Header,
    DeleteSearch,
  },
  data(){
    return {
      total: 0, // 总数 
      pageNum: 1, // 页码 
      pageSize: 10, // 条数
      searchData: {}, // 搜索数据


      WTableOpts: {
        data: [],
        tableAttrs: { border: false },
        tableColAttrs: [
          // { prop: '', label: '订单编号', slotName: 'payOrderId', width: '200px' },
          { prop: '', label: '主提单号', slotName: 'masterBillNo', width: '200px' },
          { prop: '', label: '分提单号', slotName: 'houseBillNo', width: '200px' },
          { prop: '', label: '船名', slotName: 'shipName', width: '150px' },
          { prop: '', label: '航次', slotName: 'voyageNo', width: '150px' },
          { prop: 'carrier', label: '船公司', width: '100px' },
          { prop: 'shipAgent', label: '船代', width: '100px' },
          { prop: '', label: '预配回执状态', slotName: 'ackStatus', width: '110px' },
          { prop: '', label: '预配回执摘要', slotName: 'ackContent', width: '200px' },
          { prop: '', label: '提交人', slotName: 'newOperator', width: '150px'},
          { prop: 'gmtModified', label: '操作时间', 'min-width': '200px' },
          { prop: '', label: '操作', width: '100px', slotName: 'operation',fixed:"right"  }
        ]
      },
      headers:{
        token: localStorage.getItem('userToken'),
      },
    }
  },
  
  created() {
    this.getList()
    //请求头信息补充
    let domain = '';
    if (window.location.host.split('.')[0] == 'www') {
      domain = window.location.host.split('.')[1];
    } else {
      domain = window.location.host.split('.')[0];
    }
    this.headers['X-company-domain'] = domain;
  },
  async mounted(){
    await this.$refs.deleteRecord.firstClick()
    await this.$refs.deleteRecord.fnSearch()
  },
  methods: {
    // 获取列表
    getList(){
      let params = {
        pageSize: this.pageSize,
        pageNum: this.pageNum,
        ...this.searchData,
        type: 'DELETE',
        ackStatus: (this.searchData && this.searchData.ackStatus) ? this.searchData.ackStatus.toString() : '',
      }
      httpAgent({
        url: `/agent/ccam/orders`,
        method: "get",
        data:params
      }).then((res) => {
        res.records.forEach(item => {
          if(item.ccamDispositionHistorys && item.ccamDispositionHistorys.length > 0){
            item.ccamDispositionHistorys.forEach(key => {
              if(key.type == 'ACK_STATUS'){
                item.ackStatus = key
              }
              if(key.type == 'DELETE_STATUS'){
                item.deleteStatus = key
              }
              if(key.type == 'LOAD_STATUS'){
                item.loadStatus = key
              }
              if(key.type == 'CUSTOMS_STATUS'){
                item.customsStatus = key
              }
            })
          }
        })
        
        this.WTableOpts.data = res.records
        this.total = res.total
      })
    },
    // 复制
    copy(e){
      this.$copyText(e)
			this.$message({
				type: 'success',
				message: '复制成功!'
			})
    },
    // 获取预配回执颜色 
    getAckStatus(row){
      if(row.dispositionCode == 'CCAM_DELETE_WAITING'){
        return 'w-yellow-1'
      }
      if(row.dispositionCode == 'CCAM_DELETE_SUCCESS'){
        return 'w-green-1'
      }
      if(row.dispositionCode == 'CCAM_DELETE_FAILURE'){
        return 'w-red-1'
      }
    },
    // 导出
    exportExcel(query){
      if(!query.gmtModifiedBegin && !query.gmtModifiedEnd){
        this.$message({
          message: '请选择时间',
          type: 'error'
        })
        return
      }
      query.ackStatus = (query && query.ackStatus) ? query.ackStatus.toString() : ''
      query.token = this.headers.token;
      query['X-company-domain'] = this.headers['X-company-domain'];
      let keys = Object.keys(query);
      let arr = '';
      for(let i=0;i<keys.length;i++){
        if(query[keys[i]]){
          arr = arr + '&' + keys[i] + '=' + query[keys[i]]
        }
      }
      arr = arr.substring(1);
      let url = '/agent/ccam/export?'+arr;
      console.log(url);
      window.open(url);

      // let param = {
      //   ...query,
      //   ackStatus: (query && query.ackStatus) ? query.ackStatus.toString() : '',
      // }
      // httpAgent({
      //   url: `/agent/ccam/export`,
      //   method: "get",
      //   data: param,
      //   responseType: "blob"
      // }).then((res) => {
      //   download(res, `${'CPS导出数据'}.xlsx`)
      // })
    },
    // 重置
    refreshSearch(){
      this.searchData = {}
      this.$refs.deleteRecord.refreshTime()
    },
    // 点击查询
    searchList(query){
      this.searchData = query
      this.pageNum = 1
      this.pageSize = 10
      this.getList()
    },
    // 切换条数
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.pageSize = val
      this.getList()
    },
    // 切换页码
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.pageNum = val
      this.getList()
    },

    // 查看舱单
    lookCps({ id }){
      httpAgent({
        url: `/agent/ccam/orders/${id}`,
        method: "get",
      }).then((res) => {
        let data = {
          btn: 'LOOK',
          btnName: '查看舱单',
          type: 'DELETE',
          to: 'DETAIL',
          name: '删单记录',
          content: {  ...res.houseBill }
        }
        this.$router.push({
          name:"cpsDetail",
          query:data
        })
      })
    },
    // 复制舱单
    copyCps({ id }){
      httpAgent({
        url: `/agent/ccam/orders/${id}`,
        method: "get",
      }).then((res) => {
        let response = { ...res }
        response.masterBillNo = ''
        let data = {
          btn: 'COPY',
          btnName: '复制舱单',
          type: 'DELETE',
          to: 'DETAIL',
          name: '删单记录',
          content: {  ...response.houseBill }
        }
        this.$router.push({
          name:"cpsDetail",
          query:data
        })
      })
    },
   
    
    // 关闭弹窗
    closeDialog(){

    },
    
  }
};
</script>

<style scoped lang="less">
.send-record {
  font-size: 14px;
  color: #333333;
  display: flex;
  flex-direction: column;
  height: 100%;
  .send-record-content {
    position: relative;
    background: #ffffff;
    border-radius: 4px;
    padding: 24px;
    height: 100%;
  }
  .icon-fuzhi {
    color: #1170eb;
    font-size: 12px;
    cursor: pointer;
    margin-left: 10px !important;
  }
  .icon-shuaxin {
    font-size: 14px;
    color: #000000;
    cursor: pointer;
    margin-left: 6px !important;
  }

  .icon-tijiaoguimianshandan {
    font-size: 12px;
    margin-right: 4px !important;
  }
  .el-button--primary {
    margin-bottom: 24px;
  }
}
</style>
